<template>
<!-- <div> -->
  <v-autocomplete
    v-model='selected'
    @focus='get'
    @click:prepend='get'
    :loading='loading'
    :items='items'
    :errorMessages='errorMessages'
    prepend-icon='mdi-reload'
    v-bind='attrs' >
  </v-autocomplete>
  <!-- {{selected}} -->
  <!-- <div v-for='item in items' :key='item.value' >{{item.value}}: {{item.text}}</div> -->
<!-- </div> -->
</template>
<script>
import axios from 'axios'

export default {
  name: 'HttpAutocomplete',
  props: {
    value: { required: true },
    href: { type: String, required: true },
    attrs: { type: Object, default: () => {} },
    valueMapper: { type: Function, required: false },
    errorMessages: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      selected: {},
      items: [],
      loading: false,
      hasError: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          if (this.items.length === 0) {
            this.items.push(
              {text: this.value, value: this.value}
            )
          }
          this.selected = this.value
        }
      }
    },
    selected () {
      this.$emit('input', this.selected)
    }
  },
  methods: {
    get () {
      let vm = this
      this.loading = true
      this.hasError = false
      axios.get(this.href)
        .then((response) => {
          vm.items = []
          if (this.valueMapper) {
            vm.items = response.data.map(this.valueMapper)
          } else {
            vm.items = response.data
          }
          vm.loading = false
        })
        .catch((error) => {
          vm.err = error
          vm.hasError = true
          vm.loading = false
        })
    }
  },
  computed: {

  }
}
</script>
